
















































import { ComponentInstance, computed, defineComponent, getCurrentInstance, onMounted, ref } from '@vue/composition-api';
import AppLinks from '@k/appLinks';
// @ts-ignore xxx
import { zs } from '@zyb-data/stats-h5';
import urlExt from '@k/url';
import { isAndroid, isiOS } from '@/kits/system';
import { useHarmonyLink } from '@/hooks/useHarmonyLink';

window.channelfr = urlExt.getQuery('channelfr') || '';

interface BookInfo {
  name: '';
  bookId: '';
  chapterList: Array<{
    chapterTitle: string;
  }>;
  cover: '';
  isExist: 1;
  version: '';
}

export default defineComponent({
  setup() {
    const bookId = new URLSearchParams(location.search).get('bookId');

    const bookInfo = ref<BookInfo>({
      name: '',
      bookId: '',
      chapterList: [],
      cover: '',
      isExist: 1,
      version: ''
    });

    const onlyOneChapter = computed(() => bookInfo.value.chapterList.length <= 1);

    onMounted(() => {
      const vm = getCurrentInstance()?.proxy as ComponentInstance;
      const getPageData = async function () {
        const params = {
          bookId
        };
        try {
          const getType = 'get';
          const { errNo, data } = await vm.$http[getType](vm.api.book.detail, params);
          if (errNo == 0) {
            bookInfo.value = data;
          }
        } catch (e) {
          console.log(e);
        }
      };
      getPageData();

      zs.track('F37_001', {
        bookId,
        channelfr: window.channelfr
      });
    });

    const scheme = `dxst://com.zmzx.college.search/na/bookDetail?bookId=${bookId}`;
    const App = new AppLinks({
      universalLink: '',
      nativeLinkIos: scheme,
      nativeLinkAndroid: scheme
    });

    const onDownload = () => {
      const universalLink =
        'https://m.daxuesoutijiang.com/dx-h5/appdownload.html?url=' +
        encodeURIComponent('app://dxst/answer/bookDetail?bookId=' + bookId);
      if (isiOS && isAndroid) {
        App.active();
      } else {
        useHarmonyLink(universalLink);
      }
    };

    const ongoDownload = () => {
      onDownload();
      zs.track('F37_002', {
        bookId,
        channelfr: window.channelfr
      });
    };

    const onExpand = () => {
      zs.track('F37_003', {
        bookId,
        channelfr: window.channelfr
      });
      onDownload();
    };

    return {
      bookInfo,
      onlyOneChapter,
      onDownload,
      ongoDownload,
      onExpand
    };
  }
});
